import { create } from 'zustand';

interface HeaderState {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  setMenuOpen: (open: boolean) => void;
}

export const useHeaderStore = create<HeaderState>((set) => ({
  isMenuOpen: false,
  
  toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
  
  setMenuOpen: (open) => set({ isMenuOpen: open }),
})); 